import * as React from 'react';
import * as Yup from 'yup';
import { Form, withFormik } from 'formik';
import ServiceSelect from 'components/Select/ServiceSelect';
import StateSelect from 'components/Select/StateSelect';
import './overrides.css';
const Filter = () => (React.createElement("div", { className: "choose-box" },
    React.createElement("p", null, "Choose your state to see our rates"),
    React.createElement(Form, null,
        React.createElement("div", { className: "drp-area services-page" },
            React.createElement(StateSelect, { name: "stateId", title: "State:", placeholder: "Choose State" }),
            React.createElement(ServiceSelect, { name: "serviceId", title: "Service:", placeholder: "Choose Service" }),
            React.createElement("input", { type: "submit", className: "check-rate", value: "Check Rate" })))));
export default withFormik({
    mapPropsToValues: () => ({
        stateId: '',
        serviceId: '',
    }),
    validateOnBlur: false,
    validationSchema: Yup.object().shape({
        stateId: Yup.string().label('State').required(),
        serviceId: Yup.string().label('Court').required(),
    }),
    handleSubmit: (values, { props, setSubmitting }) => {
        props.onSubmit(values);
        setSubmitting(false);
    },
})(Filter);
